import React from "react"
import Layout from "../components/Layout"
import { Link } from "gatsby"
import { isBrowser } from "../services/firebase"

const NotFoundPage = () => {
  if (isBrowser && window) {
    return (
      <Layout
        title="Not Found"
        description="That page doesn't exist or has been removed."
      >
        <section className="section">
          <div className="container">
            <div className="content">
              <h1>404 Not Found</h1>
              <p>
                Sorry, that page doesn't exist or has been removed from our
                website.
              </p>
              <Link className="button is-link" to="/">
                Back to Home Page
              </Link>
            </div>
          </div>
        </section>
      </Layout>
    )
  } else {
    return null
  }
}

export default NotFoundPage
